import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createHideLoadingIndicatorAction, createShowLoadingIndicatorAction } from "@multiweb/reactCore/bridge";
import { getObjectName, getOriginalAttributeName } from "@multiweb/reactCore/datasource";
import { IAppState } from "@multiweb/types/react";
import { DocumentDownloadComponent, DocumentDownloadComponentProps } from "../DocumentDownloadComponent";

type DocumentDownloadProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
    /** Název atributu po zpracování dat z api - začíná malým písmenem */
    attributeName: string;
} & Pick<DocumentDownloadComponentProps, "attributeValue" | "recordId">;
type StateProps = Pick<DocumentDownloadComponentProps, "objectName" | "originalAttributeName">;
type DispatchProps = Pick<DocumentDownloadComponentProps, "showLoadingIndicator" | "hideLoadingIndicator">;

const mapStateToProps: MapStateToProps<StateProps, DocumentDownloadProps, IAppState> = (state, { dataSourceKey, attributeName }) => ({
    originalAttributeName: getOriginalAttributeName(state, { dataSourceKey, attributeName }),
    objectName: getObjectName(state, dataSourceKey),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, DocumentDownloadProps> = {
    showLoadingIndicator: createShowLoadingIndicatorAction,
    hideLoadingIndicator: createHideLoadingIndicatorAction,
};

export const DocumentDownload = connect(mapStateToProps, mapDispatchToProps)(DocumentDownloadComponent);
